<template>
  <el-container id="numeral-screen">
    <el-col class="numeral-map">
      <common-map v-if="siteList != null" :key="siteList" :siteList="siteList" />
    </el-col>

    <el-col class="screen-top-row" :class="{'screen-top-row-full': !isFullscreen}">
      <el-row class="screen-date-area" :class="{'screen-date-area-full': !isFullscreen}">时间:{{new Date().Format('yyyy-MM-dd')}}</el-row>
      <el-row class="screen-title-area">能碳综合管理平台</el-row>
      <el-row class="screen-btn-area">
        <el-col class="screen-change-btn" @click.native="toggleFullScreen">
          {{ isFullscreen?"全屏":"恢复" }}
          <el-col v-if="isFullscreen" class="screen-full-btn-icon"></el-col>
          <el-col v-else class="screen-return-btn-icon"></el-col>
        </el-col>
      </el-row>
    </el-col>
    <el-col :class="isFullscreen?'left-col':'left-col-full'" :key="isFullscreen+rightStamp">
      <digital-block v-for="block in blocks" :key="block.index" :block-index="block.index" :block-data="block" :source-data="brief" :isFull="isFullscreen"/>
    </el-col>

    <el-col :class="isFullscreen?'middle-col':'middle-col-full'" :key="isFullscreen+rightStamp">
      <station-block :isFull="isFullscreen" :site-num="brief.siteNum"/>
      <online-block :isFull="isFullscreen" :sensor-num="[brief.onlineNum, brief.deviceNum]"/>
    </el-col>

    <el-col :class="isFullscreen?'right-col':'right-col-full'" :key="isFullscreen+rightStamp">
      <coal-block :is-full="isFullscreen" :coal-data="brief"/>
      <warning-block :is-full="isFullscreen" :alarm-map="brief.alarmMap" :alarm-list="brief.alarmList"/>
    </el-col>
  </el-container>
</template>

<script>
import CommonMap from "../../common/map/CommonMap";
import DigitalBlock from "../DigitalScreen/DigitalBlock";
import StationBlock from "../DigitalScreen/StationBlock";
import OnlineBlock from "../DigitalScreen/OnlineBlock";
import CoalBlock from "../DigitalScreen/CoalBlock";
import WarningBlock from "../DigitalScreen/WarningBlock";

export default {
  name: "SiteScreen1",
  components: {WarningBlock, CoalBlock, OnlineBlock, StationBlock, DigitalBlock, CommonMap},
  data() {
    return {
      isFullscreen: false,
      blocks: [
        {index: 0, typeName: '电', unit: '度', color: '#12C5C0', valueProp: ['dayEnergy', 'lastEnergy', 'energyProp', 'monEnergy'], icon: 'zy-icon-ele'},
        {index: 1, typeName: '水', unit: '立方米', color: '#027DDA', valueProp: ['dayWater', 'lastWater', 'waterProp', 'monWater'], icon: 'zy-icon-water'},
        {index: 2, typeName: '气', unit: '立方米', color: '#FB9E1E', valueProp: ['dayGas', 'lastGas', 'gasProp', 'monGas'], icon: 'zy-icon-gas'},
        {index: 3, typeName: '热', unit: '立方米', color: '#39BD67', valueProp: ['dayHeat', 'lastHeat', 'heatProp', 'monHeat'], icon: 'zy-icon-gas'}
      ],
      brief: {dayEnergy: '453.4', lastEnergy: '-', energyProp: '-', monEnergy: '-', dayWater: '-', lastWater: '-', waterProp: '-', monWater: '-',
        dayGas: '-', lastGas: '-', gasProp: '-', monGas: '-', dayHeat: '-', lastHeat: '-', heatProp: '-', monHeat: '-',
        dayCoal: '-', lastCoal: '-', coalProp: '-', energyCoal: '', waterCoal: '', gasCoal: '', heatCoal: '',
        runDay: '-', alarmNum: '-', siteNum: '-', commNum: '-', sensorNum: [0, 0], alarmMap: {}, coalCurve: {}, alarmList: {}
      },
      siteList: null,
      mapRefreshCount: 10,
      screenTimeout: null,
      rightStamp: 0
    }
  },
  created() {
    let _self = this;
    addEventListener("fullscreenchange", function (e) {
      if (document.fullscreenElement) {
        console.log('进入全屏', _self.isFullscreen)
      } else {
        if(!_self.isFullscreen) {
          _self.isFullscreen = true;
        }
      }
    })
    this.$nextTick(function() {
      this.toggleFullScreen(null);
    })
    this.getScreenData();
    if (this.screenTimeout === null) {
      this.screenTimeout = setInterval(() => {
        this.getScreenData();
      }, 5 * 60 * 1000);
    }
  },
  beforeDestroy() {
    // removeEventListener("fullscreenchange", false)
    this.brief = null;
    this.siteList = null;
    if (this.screenTimeout !== null) {
      clearInterval(this.screenTimeout)
    }
  },
  methods: {
    getScreenData() {
      if(this.mapRefreshCount >= 10) {
        this.$api.energyDisplay.getSiteList().then(res => {
          this.siteList = res.data;
        })
        this.mapRefreshCount = 0;
      }
      this.mapRefreshCount++;
      this.$api.energyDisplay.getDigitalScreenData().then(res => {
        this.brief = res.data;
        this.rightStamp = new Date().getTime();
      });
    },
    FullScreen(el) {
      if(this.isFullscreen) { // 退出全屏
        if(document.exitFullscreen) {
          document.exitFullscreen()
        }else if(document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        }else if(document.webkitExitFullscreen) {
          // 改变平面图在google浏览器上面的样式问题
          $("#numeral-screen").css("position", "static").css("width", "100%");
          $(".buildingsFloor").css("width", "70%");
          $(".floor-plan").css("width", "78%");
          document.webkitExitFullscreen()
        }else if(!document.msRequestFullscreen) {
          document.msExitFullscreen()
        }
      }else { // 进入全屏
        if(el.requestFullscreen) {
          el.requestFullscreen()
        }else if(el.mozRequestFullScreen) {
          el.mozRequestFullScreen()
        }else if(el.webkitRequestFullscreen) {
          // 改变平面图在google浏览器上面的样式问题
          $("#numeral-screen").css("position", "absolute").css("width", "94%");
          $(".buildingsFloor").css("width", "98%");
          $(".floor-plan").css("width", "90%");
          el.webkitRequestFullscreen();
        }else if(el.msRequestFullscreen) {
          el.msRequestFullscreen()
        }
      }
    },
    toggleFullScreen(e) {
      console.log('toggleScreen')
      this.isFullscreen = !this.isFullscreen;
      let el = document.getElementById('numeral-screen');
      // let el=e.srcElement||e.target;//target兼容Firefox
      this.FullScreen(el);
    }
  }
}
</script>

<style scoped>
  #numeral-screen{
    width: 100%;
    height: 100%;
    background-color: #1F1F1F;
  }
  .numeral-map{
    height: 100%;
  }
  .left-col{
    position: fixed;
    top: 106px;
    left: 190px;
    width: calc(32% - 80px);
    height: 98%;
  }
  .left-col-full{
    position: fixed;
    top: 50px;
    left: 0;
    width: 31vw;
    height: 100vh;
  }
  .middle-col{
    position: fixed;
    bottom: 0;
    left: calc(32% + 118px);
    width: calc(36% - 50px);
    height: 22.22vh;
    color: #FFFFFF;
  }
  .middle-col-full{
    position: fixed;
    bottom: 10px;
    left: 31vw;
    width: 38vw;
    height: 22.22vh;
    color: #FFFFFF;
  }
  .right-col{
    position: fixed;
    top: 106px;
    right: 0;
    padding: 4px 10px 0 24px;
    width: calc(32% - 80px);
    height: 98%;
    color: #FFFFFF;
  }
  .right-col-full{
    position: fixed;
    top: 50px;
    right: 0;
    padding-right: 24px;
    width: 31vw;
    height: 98vh;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/SiteScreen/SiteScreen1.vue